import React, { FunctionComponent } from 'react';
import { useInternalBranding } from 'components/app/InternalBrandingContext';
import { Text } from 'mdlkit';
import { useIntl, FormattedMessage } from 'react-intl';
import { FocusShadowHyperlink } from 'components/shared/Styles';
import { Modal } from '../../core';

interface Props {
  isOpen: boolean;
  onDismiss(): void;
}

const ContactSupportModal: FunctionComponent<Props> = ({
  isOpen,
  onDismiss,
}: Props) => {
  const { formatMessage: f } = useIntl();
  const internalBrandingData = useInternalBranding();

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onDismiss}
      ariaLabel={f({ id: 'accountRecovery.contactSupportAriaLabel' })}
    >
      <Modal.Header>
        <FormattedMessage id="accountRecovery.contactSupportTitle" />
      </Modal.Header>
      <Modal.Content>
        <Text>
          <FormattedMessage
            id="accountRecovery.contactSupportModalBody"
            values={{
              branding: internalBrandingData?.displayName || 'MDLIVE',
              supportNumber: (
                <FocusShadowHyperlink href="tel:1-800-400-6354">
                  (800) 400-6354
                </FocusShadowHyperlink>
              ),
            }}
          />
        </Text>
      </Modal.Content>
    </Modal>
  );
};

export default ContactSupportModal;
